var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModern2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 10,
    fill: "url(#paint0_linear_4891_1017)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8875 27.3625L22.7 27.2125C22.6303 27.1652 22.5547 27.1274 22.475 27.1L22.25 27C22.0473 26.9576 21.8372 26.9663 21.6387 27.0252C21.4401 27.0841 21.2593 27.1914 21.1125 27.3375C21.0021 27.459 20.9133 27.5985 20.85 27.75C20.7554 27.9778 20.7303 28.2284 20.7778 28.4704C20.8254 28.7124 20.9434 28.9349 21.1171 29.11C21.2908 29.285 21.5125 29.4048 21.7541 29.4542C21.9957 29.5035 22.2465 29.4803 22.475 29.3875C22.6244 29.315 22.7631 29.2225 22.8875 29.1125C23.0609 28.9367 23.1784 28.7135 23.2252 28.471C23.2719 28.2285 23.2457 27.9776 23.15 27.75C23.0877 27.6055 22.9986 27.474 22.8875 27.3625ZM27 9.5H17C16.0054 9.5 15.0516 9.89509 14.3483 10.5983C13.6451 11.3016 13.25 12.2554 13.25 13.25V30.75C13.25 31.7446 13.6451 32.6984 14.3483 33.4017C15.0516 34.1049 16.0054 34.5 17 34.5H27C27.9946 34.5 28.9484 34.1049 29.6517 33.4017C30.3549 32.6984 30.75 31.7446 30.75 30.75V13.25C30.75 12.2554 30.3549 11.3016 29.6517 10.5983C28.9484 9.89509 27.9946 9.5 27 9.5ZM28.25 30.75C28.25 31.0815 28.1183 31.3995 27.8839 31.6339C27.6495 31.8683 27.3315 32 27 32H17C16.6685 32 16.3505 31.8683 16.1161 31.6339C15.8817 31.3995 15.75 31.0815 15.75 30.75V13.25C15.75 12.9185 15.8817 12.6005 16.1161 12.3661C16.3505 12.1317 16.6685 12 17 12H27C27.3315 12 27.6495 12.1317 27.8839 12.3661C28.1183 12.6005 28.25 12.9185 28.25 13.25V30.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4891_1017",
    x1: 22.5,
    y1: 0,
    x2: 22.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A63F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33E3FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModern2);
export default __webpack_public_path__ + "static/media/modern2.08bc14b8b77eb9a1adbccfb38e70894e.svg";
export { ForwardRef as ReactComponent };